<script>
  import { setTableContext } from "./TableContext.js";

  /**
   * @type {"wide"|"compact"}
   */
  export let type = "wide"

  const tableContext = setTableContext()

  let tableElement = null
  // to scroll the table horizontally when scrolling on the table header
  function horizontalScroll(delta) {
    tableElement.scrollBy(delta, 0)
  }

  $: tableContext.set({
    type,
    funcHorizontalScroll: horizontalScroll,
  })
</script>

<div class="table-wrapper">
  <table
    class:wide-table={type === "wide"}
    class:compact-table={type === "compact"}
    bind:this={tableElement}
  >
    <slot />
  </table>
</div>

<style>
  .table-wrapper {
    display: flex;
    justify-content: center;
    background-color: white;
    overflow-y: auto;
    max-width: 100vw;
    overflow-x: auto;
  }

  /* Common styles for both table modes */
  table {
    border: 1px solid #ebebeb;
    border-collapse: collapse;
    text-align: center;
  }

  /* Compact mode styles */
  table.compact-table {
    width: 100%;
    table-layout: fixed;
    word-break: break-all;
    white-space: wrap;
    overflow-x: auto;
  }

  /* Wide mode styles */
  table.wide-table {
    display: block;
    overflow-x: auto;
    white-space: nowrap;
    margin: 0 auto;
    width: auto;
  }
</style>
